import React, {useEffect, useState} from "react";
import Dialog from "@material-ui/core/Dialog";
import moment from "moment";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Filters from "./StatPopupFilters";
import {getPurchases} from "../../services/clientsService";
import Http from "../../Http";
import {CLIENTS_ROUTES} from "../../config/routes";
import {Grid, Typography, withStyles} from "@material-ui/core";
import Select from "../Select";
import Pagination from "@material-ui/lab/Pagination";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

function EnhancedTableHead(props) {

    return (
        <TableHead>
            <TableRow>
                
                <TableCell
                    key={'Дата'}
                    align={'left'}
                >

                    {'Дата'}

                </TableCell>
                <TableCell
                    key={'Тип'}
                    align={'left'}
                >

                    {'Тип'}

                </TableCell>
                <TableCell
                    key={'Стоимость'}
                    align={'left'}
                >

                    {'Стоимость'}

                </TableCell>
               
            </TableRow>
        </TableHead>
    );
}

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const StatPopup = (props) => {
    let dt = new Date();
    dt.setHours(dt.getHours() - dt.getTimezoneOffset() / 60);

    let df = new Date(dt.getTime() - 86400000 * 7);
    df.setHours(df.getHours() - df.getTimezoneOffset() / 60);

    const [dateFrom, setDateFrom] = useState(df)
    const [dateTo, setDateTo] = useState(dt)
    const [purchases, setPurchases] = useState([])
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(10)
    const [total, setTotal] = useState(0)

    useEffect(() => {
        if (props.client) {
            Http.get(`${CLIENTS_ROUTES.getClientPurchases}?clientId=${props.client}&dateFrom=${moment(dateFrom).format('YY-MM-DD H:m:s')}&dateTo=${moment(dateTo).format('YY-MM-DD H:m:s')}&page=${page}&perPage=${perPage}`)
                .then(res => {
                    setPurchases(res.data.data)
                    setTotal(res.data.total)
                })
        }
        
    }, [props.client, dateFrom,dateTo, page, perPage]);
    
    return(
        <div style={{width: '500px'}}>
            <Dialog fullWidth maxWidth={false} open={props.open} onClose={() => {
                setTotal(0)
                setPerPage(10)
                setPage(1)
                props.onClose()
                setPurchases([])
            }} aria-labelledby="form-dialog-title"
                    style={{textAlign: "center", width: '724px', left: '50%', marginLeft: '-362px'}} >
                <DialogTitle style={{backgroundColor: '#f9f9f9'}} id="form-dialog-title"><b>Статистика</b></DialogTitle>
                    <DialogContent style={{textAlign: "center", marginBottom: '30px', marginTop: '30px'}}>
                        <Filters dateFrom={dateFrom} dateTo={dateTo} setDateFrom={setDateFrom} setDateTo={setDateTo}/>
                        <TableContainer>
                            <Table
                                aria-labelledby="tableTitle"
                                size={'medium'}
                                aria-label="enhanced table"
                            >
                                <EnhancedTableHead/>

                                <TableBody>
                                    {

                                        purchases.map((row, index) => {

                                            const labelId = `enhanced-table-checkbox-${index}`;

                                            return (

                                                <StyledTableRow
                                                >
                                                    <TableCell component="th" id={labelId} scope="row">
                                                        {moment.utc(row.created_at).local().format('YYYY-MM-DD HH:mm:ss')}
                                                    </TableCell>
                                                    <TableCell align="left">{row.type}</TableCell>
                                                    <TableCell align="left">{row.cost / 100 + ' UAH'}</TableCell>


                                                </StyledTableRow>
                                            );
                                        })}

                                </TableBody>

                            </Table>
                        </TableContainer>
                        <Grid container style={{marginTop: '30px'}}>
                            <Grid item xs={12} sm={12} md={12} lg={12} style={{
                                display: 'flex',
                                aligItems: 'center',
                                fontSize: '11px',
                                alignItems: 'center',
                                color: 'gray'
                            }}>
                                <Typography variant={'span'} style={{'marginRight': '10px'}}>
                                    Записей на странице
                                </Typography>
                                <Select
                                    value={perPage}
                                    type={'select'}
                                    rowsPerPageOptions={[10, 25, 50, 100, 'ВСЕ']}
                                    borderRadius={'20px 20px'}
                                    width={'76px'}
                                    onChange={(e) => setPerPage(e)}
                                />

                                {perPage !== 'ВСЕ' && <Pagination
                                    style={{color: '#ffffff'}}
                                    count={Math.ceil(total / perPage)}
                                    color="primary"
                                    page={page}
                                    onChange={(e, newPage) => setPage(newPage)}
                                    size={'large'}/>}
                            </Grid>
                        </Grid>
                    </DialogContent>
            </Dialog>
        </div>
    )
}

export default StatPopup